import { sheetListSummary } from "./consolidationSheetChecks.js";
import { workedSeconds } from "./consolidationPresentation.js";

const dayFormat = new Intl.DateTimeFormat("fr-CA", { weekday: "long", day: "numeric", month: "long", timeZone: "UTC" });
const shortFormat = new Intl.DateTimeFormat("fr-CA", { day: "numeric", month: "long", timeZone: "UTC" });
const monthFormat = new Intl.DateTimeFormat("fr-CA", { month: "long", year: "numeric", timeZone: "UTC" });
const utc = day => new Date(`${day}T12:00:00Z`);
const capitalize = text => text.charAt(0).toLocaleUpperCase("fr") + text.slice(1);
export const driverIdentity = value => String(value || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase("fr").replace(/\s+/g, " ").trim();

export function periodTitle(mode, from, to) {
  if (mode === "day") return capitalize(dayFormat.format(utc(from)));
  if (mode === "month") return capitalize(monthFormat.format(utc(from)));
  const sameMonth = from.slice(0, 7) === to.slice(0, 7);
  const start = sameMonth ? String(utc(from).getUTCDate()) : shortFormat.format(utc(from));
  return `${mode === "week" ? "Semaine du" : "Du"} ${start} au ${shortFormat.format(utc(to))}`;
}

// Rounded to the minute, like the calculation details, so parts add up to their total.
export const hoursLabel = seconds => { const minutes = Math.round(seconds / 60); return `${Math.floor(minutes / 60)} h ${String(minutes % 60).padStart(2, "0")}`; };

// One state per driver line: validated only when all its routes are, in progress as soon as one is saved.
export function routeGroupStatus(routes) {
  if (routes.length && routes.every(route => route.sheet.status === "validated")) return "validated";
  return routes.some(route => route.sheet.id && route.sheet.status === "draft") ? "draft" : "expected";
}

const trailerName = sheet => sheet.dispatch_assignment?.compartment_name || null;

// Lines of the day list, in Dispatch order, with what the dispatcher needs to choose the next relevé.
export function dayNavigatorItems(day) {
  const drivers = day.driver_groups.map(group => {
    const sheets = group.routes.map(route => route.sheet);
    const summary = sheetListSummary(sheets);
    return {
      key: `driver:${group.key}`, employee: group.key, kind: "driver", label: group.driver_name || "Chauffeur identifié", routes: group.routes,
      trucks: [...new Set(sheets.map(sheet => sheet.truck_number).filter(Boolean))],
      trailers: [...new Set(sheets.map(trailerName).filter(Boolean))],
      evening: sheets.every(sheet => sheet.dispatch_period === "evening"),
      dompeur: sheets.some(sheet => sheet.dispatch_assignment?.truck_type === "dompeur"),
      orderCount: new Set(group.routes.flatMap(route => route.orders.map(order => order.id))).size,
      status: routeGroupStatus(group.routes), summary,
      worked: sheets.every(sheet => workedSeconds(sheet) != null) ? sheets.reduce((total, sheet) => total + workedSeconds(sheet), 0) : null,
    };
  });
  if (day.unassigned_routes?.length) drivers.push({
    key: "unassigned", kind: "driver", label: "Tournées sans chauffeur identifié", routes: day.unassigned_routes,
    trucks: [...new Set(day.unassigned_routes.map(route => route.sheet.truck_number).filter(Boolean))], trailers: [],
    orderCount: new Set(day.unassigned_routes.flatMap(route => route.orders.map(order => order.id))).size,
    status: routeGroupStatus(day.unassigned_routes), summary: sheetListSummary(day.unassigned_routes.map(route => route.sheet)), worked: null,
  });
  return drivers;
}

export const NAVIGATOR_GROUPS = [["draft", "En cours"], ["expected", "À saisir"], ["validated", "Validés"]];

// Journées tab: relevés by status (progress card, tab counter) and the day's orders.
export function dayOverview(day) {
  const sheets = [...day.driver_groups.flatMap(group => group.routes), ...(day.unassigned_routes || [])].map(route => route.sheet);
  const count = status => sheets.filter(sheet => (sheet.status === "validated" ? "validated" : sheet.id ? "draft" : "expected") === status).length;
  return { total: sheets.length, validated: count("validated"), drafts: count("draft"), expected: count("expected"),
    unassigned: day.unassigned_orders?.length || 0, orders: day.order_count };
}
